export const ACCOUNT_CONTEXT_SWITCH_SUCCEEDED = "accountContext/switchSucceeded" as const;

export type AccountContextSwitchSucceededAction = {
  type: typeof ACCOUNT_CONTEXT_SWITCH_SUCCEEDED;
};

export const accountContextSwitchSucceeded = (): AccountContextSwitchSucceededAction => ({
  type: ACCOUNT_CONTEXT_SWITCH_SUCCEEDED,
});
